export type PageSize = {
  id?: string
  isCustom?: boolean
  name?: string
  height: number
  width: number
}
export type BadgeSize = PageSize

export type TemplateType = "badge" | "schedule"
export type EditType = "readonly" | "edit"
export type PaperType = "multi" | "template"

export type PageMargins = {
  top: number
  bottom: number
  left: number
  right: number
  centerH: boolean
  centerV: boolean
}
export type BadgeMargins = { right: number; bottom: number }
export type GridSize = { rows: number; columns: number }
export type BoxDimension = { width: number; height: number }
export type UnitType = 'cm' | 'inch' | 'pixel'


export interface Image {
  id: string
  preview: string
  original: string
}

export const enum PageOption {
  SINGLE = "single",
  MULTI = "multi",
}

export const PageTypes = {
  IDENTICAL: "identical" as PageSource,
  MIRROR: "mirror" as PageSource,
  CUSTOM: "custom" as PageSource,
}

export const enum PageSource {
  IDENTICAL = "identical",
  CUSTOM = "custom",
}

export type SinglePageData = {
  templateData: {
    background: string
    objects: any[]
  }
  pageLabel: string
  pageSource?: PageSource
  printRotation?: boolean
  isLocked?: boolean
  index: number
}
export type PagesData = SinglePageData[]

export interface LayoutSettings {
  type: PaperType
  pageMargins: PageMargins
  badgeMargins: BadgeMargins
  gridSizes: { custom: GridSize; calculated: GridSize }
  paperSize: BoxDimension
}

export interface CodeSettings {
  type: "QR_CODE" | "BAR_CODE"
  content: string //ticketId | orderId | badgeId | Vcard | Custom
  barcodeType?: "code39" | "code128" | "ean13" | "ean8" | "upc" | "upce" | "codabar"
  barLineWidth?: number
  barCode?: number //TODO: what is this for? Remove if not needed
}

type Variant = { label: string; value: string; targetKey: string; targetValue: string }

export type LabelItem = {
  defaultLabel?: string
  label: string
  column: string
  isTemplate?: boolean
  templateId?: number
  type?: "multi" | "template" | "combo" | "paragraph" | "multiBadgeImage" | "multiBadgeLabel"
  text?: string
  variants?: Variant[] | string[]
  isMultiPick?: boolean
  isCombo?: boolean
  isParagraph?: boolean
  isImageLabel?: boolean
  isMultiBadgeLabel?: boolean
  delimiter?: string
  defaultDelimiter?: string
  // when we format the field as row or column, we need to store the original text.
  // This is because we need to be able to switch back to the original text when we switch formatting
  baseText?: string
  section?: string
}
export type LabelData = { [key: string]: LabelItem }
